export default __webpack_public_path__ + "static/media/near-icon.6fa2597c.png";